import type { InputHTMLAttributes } from 'react';

import { cx } from '../lib/cx.ts';
import { useFieldState } from './Field.tsx';

export const controlClasses = cx(
  /*
   * `min-w-0` alongside `w-full`: WebKit gives `input[type=date]` an
   * intrinsic width wide enough for the whole date and will let it push out
   * of its container rather than shrink. Harmless for every other input.
   */
  'w-full min-w-0 min-h-touch rounded-md border bg-surface-sunken px-3 py-2',
  'text-base text-text placeholder:text-faint',
  'border-line hover:border-line-strong',
  'aria-invalid:border-danger',
  'disabled:opacity-50',
  'transition-colors duration-(--ui-duration-fast)',
);

type TextInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> & {
  className?: string;
};

export function TextInput({ className, ...rest }: TextInputProps) {
  const field = useFieldState();

  return (
    <input
      id={field?.inputId}
      aria-describedby={field?.describedBy}
      aria-invalid={field?.invalid || undefined}
      className={cx(controlClasses, className)}
      {...rest}
    />
  );
}
